/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IContentBlockViewProps } from '@msdyn365-commerce-modules/content-block/src/modules/content-block/./content-block';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { Image, /*IImageSettings, IImageProps*/ } from "@msdyn365-commerce/core";
import { getFeatureToggleService } from '../../../services/featureToggleService';
import { IContentBlockConfig } from '../definition-extensions/content-block.ext.props.autogenerated';


const DEFAULT_IMAGE_MODE = 2

type IContentBlockFullConfig = IContentBlockConfig & {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- This field comes from SDK.
    msdyn365__moduleLayout?: string;
}

const ContentBlockView: React.FC<IContentBlockViewProps> = props => {
    const { contentBlockContainer, imageContainer, detailsContainer, title, text, links, image : imageProp } = props;
    const { image } = props.config;
    //@ts-ignore
    const imageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: {
            ...image?.imageSettings,
            mode: image?.imageSettings?.mode || DEFAULT_IMAGE_MODE
        }
    };
    //@ts-ignore
    const htmlImage = imageProp && <img src={imageProp.props.src} alt={imageProp.props.altText}  title={imageProp.props.title} />;
    //@ts-ignore
    const msdynImage = <Image
        {...image}
        {...imageProps}
        requestContext={props.context.request}
        
        editProps={{
            key: image ?? {},
            requestContext: props.context.request,
            moduleType: props.typeName,
            imagePropertyName: 'image',
            moduleId: props.id,
            layout: (props.config as IContentBlockFullConfig).msdyn365__moduleLayout
        }}
        preserveImageSpace
        shouldSkipToMainImage
    />;
    const { isFeatureEnabled } = getFeatureToggleService(props.context.request.cookies, props.context.app.config.features);

    const contentBlockImage = isFeatureEnabled('msdyn-image') ? msdynImage : htmlImage;

    const entireLink = contentBlockContainer.className.includes('linkplacement__entirebanner');
    // @ts-ignore
    const link = links && 'props' in links ? links.props.links[0].linkUrl.destinationUrl : '';
    return (
        <Module {...contentBlockContainer}>
            {entireLink ? (
                <a href={link}>
                    <Node {...imageContainer}>{contentBlockImage}</Node>
                    <Node {...detailsContainer}>
                        {title}
                        {text}
                    </Node>
                </a>
            ) : (
                <>
                    {image && <Node {...imageContainer}>{contentBlockImage}</Node>}
                    <Node {...detailsContainer}>
                        {title}
                        {text}
                        {links}
                    </Node>
                </>
            )}
        </Module>
    );
};

export default ContentBlockView;
